/* eslint-disable no-shadow */
import { useNavigation } from "@react-navigation/native";
import React, { useEffect, useState } from "react";
import {
  ActivityIndicator,
  FlatList,
  StyleSheet,
  TouchableOpacity,
  View,
  Linking,
} from "react-native";
import { useDispatch } from "react-redux";
import t from "@constants/localization";
import EmptyOrdersGraphic from "@assets/svg/EmptyOrdersGraphic";
import NoOrdersGraphic from "@assets/svg/NoOrdersGraphic";
import Text from "@components/AppText";
import colors from "@constants/color";
import metrics, { isSmallScreen } from "@constants/metrics";
import { actions } from "@reducers/cartReducer";
import { actions as orderActions } from "@reducers/orderReducer";
import analytics from "@services/analytics";
import { MY_ORDERS_EVENTS, CUSTOMER_PAGE } from "@constants/analyticsEventsCT";
import GroupBuyOfferCard from "./GroupBuyOfferCard";
import OrderCard from "./OrderCard";
import { scale } from "../../../utils/scale";

const PATH = "screens/Vacation/index";

const OrdersListView = ({
  testID,
  orders,
  onPressOrder = () => {},
  contentContainerStyle = {},
  fetchCommunityLeaderOrders = (e) => {},
  loading,
  canFetchOrders = true,
  showUserName = true,
  showPhone = true,
  horizontal = false,
  onScroll = () => {},
  userId = null,
  isPulled = false,
  waText = false,
  pulledFunc = () => {},
  listRef = () => {},
  setReasonsModalVisible = () => {},
  activeGroupBuyOffers = [],
  clearSearchQuery = () => {},
  ListHeaderComponent = () => {},
  isProfileShow,
  eventProps,
  isVacationOrder = false,
}) => {
  const navigation = useNavigation();
  const dispatch = useDispatch();

  const handleNewOrderClick = (userId) => {
    if (!userId) return;

    dispatch(actions.setNewCustomerForOrder(userId));
    navigation.navigate("NewOrderPlaceScreen");

    // analytics.trackEvent(VIEW_CATEGORY, {
    //   category_url: "hot-deals",
    //   category_name: "Hot Deals",
    //   screen: "customer-profile",
    //   action: "clicked",
    // });
  };

  const onWaShare = (share_message, user_phone, order_id) => {
    // shareTextonWhatsApp(share_message);
    user_phone &&
      Linking.openURL(
        `whatsapp://send?text=${share_message}&phone=+91${user_phone}`,
      );
    if (waText === "बिल शेयर करें") {
      analytics.trackEvent(CUSTOMER_PAGE.CX_DETAIL_SHARE_BILL, {
        cx_id: userId,
        order_id,
      });
    } else {
      analytics.trackEvent(MY_ORDERS_EVENTS.ORDER_SHARE, {
        order_id,
      });
    }
  };

  const emptyComponent = () => {
    return (
      <View
        style={{
          flex: 1,
          justifyContent: "center",
          alignItems: "center",
          padding: 20,
          backgroundColor: colors.white,
        }}
      >
        {showUserName ? (
          <TouchableOpacity
            testID="olv-btn "
            onPress={() => {
              showUserName
                ? navigation.navigate("Customers")
                : handleNewOrderClick(userId);
            }}
          >
            <View style={[styles.btnContainer, { flexDirection: "column" }]}>
              <EmptyOrdersGraphic />
              <Text
                fontType="content1"
                style={{ textAlign: "center", marginTop: 10 }}
              >
                आपने अभी तक कोई आर्डर नहीं किया है | अपने कस्टमर के लिए अभी
                आर्डर करें |
              </Text>
              <View style={styles.orderNewButton}>
                <Text
                  bold
                  fontType="content1"
                  style={{ color: colors.white, textAlign: "center" }}
                >
                  आर्डर करें
                </Text>
              </View>
              {/* <Text fontType="content1" style={{ paddingBottom: 20 }}>No Orders</Text>
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              <Text fontType="content1" style={{ marginRight: 10 }}>
                नया आर्डर प्लेस करे
              </Text>
              <Caret />
            </View> */}
            </View>
          </TouchableOpacity>
        ) : (
          <View>
            <NoOrdersGraphic />
            <Text
              fontType="content1"
              style={{
                color: colors.lightBlack,
                textAlign: "center",
                paddingTop: 20,
              }}
            >
              {t(`${PATH}/noOrder`)}
            </Text>
          </View>
        )}
      </View>
    );
  };

  const renderGroupBuyOffer = (gb = {}, activeGroupBuyOffers = []) => {
    const gbsLength = activeGroupBuyOffers && activeGroupBuyOffers.length;
    const containerWidth =
      gbsLength === 1 ? metrics.screenWidth * 0.9 : metrics.screenWidth * 0.85;
    const containerHeight = isSmallScreen
      ? metrics.screenHeight / 4
      : metrics.screenHeight / 5;

    return (
      <View
        style={{
          height: containerHeight,
          minHeight: metrics.screenHeight / 5,
          width: containerWidth,
          alignSelf: "center",
          marginRight: 10,
        }}
      >
        <GroupBuyOfferCard gbOffer={gb} />
      </View>
    );
  };

  const renderActiveGroupBuyOffers = () => {
    return Array.isArray(activeGroupBuyOffers) &&
      activeGroupBuyOffers.length ? (
      <FlatList
        horizontal
        style={{ padding: 10 }}
        showsHorizontalScrollIndicator={false}
        data={activeGroupBuyOffers}
        keyExtractor={(item) => item.id}
        ListHeaderComponent={ListHeaderComponent}
        renderItem={({ item }) =>
          renderGroupBuyOffer(item, activeGroupBuyOffers)
        }
      />
    ) : (
      <></>
    );
  };

  const navigateToDetails = (order_id, source) => {
    dispatch(
      orderActions.setSelectedOrder({
        orderId: parseInt(order_id, 10),
        isVacationOrder,
        source,
      }),
    );
    navigation.navigate("OrderDetails");
    if (eventProps) {
      analytics.trackEvent(eventProps.event, {
        order_id,
        ...eventProps,
      });
    } else {
      analytics.trackEvent(MY_ORDERS_EVENTS.ORDER_CARD_CLICK, {
        order_id,
      });
    }
  };

  const navigateToRating = (navParams) => {
    navigation.navigate("RateOrder", navParams);
  };

  const [singleOrder, setSingleOrder] = useState(true);

  const [allOrders, setAllOrder] = useState(isProfileShow);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (orders.length > 1) setSingleOrder(false);
  });

  return (
    <>
      {!orders.length && loading ? (
        <View
          style={{
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ActivityIndicator size="large" color={colors.primary} />
        </View>
      ) : (
        <FlatList
          // TODO: orders seem to have items with duplicate order id debug later
          testID={testID}
          data={orders}
          keyExtractor={(item) => item.order_id}
          showsVerticalScrollIndicator={false}
          showsHorizontalScrollIndicator={false}
          ref={(view) => {
            listRef(view);
          }}
          style={{ flex: 1 }}
          renderItem={({ item, index }) => {
            return (
              <>
                {index === 0 && renderActiveGroupBuyOffers()}
                <TouchableOpacity
                  testID="olv-order-card"
                  style={
                    allOrders
                      ? styles.allOrders
                      : singleOrder
                        ? horizontal
                          ? styles.singleOrderHorizontal
                          : styles.singleOrder
                        : index === orders.length - 1
                          ? styles.orderListLastCard
                          : styles.orderList
                  }
                  onPress={() => onPressOrder(item)}
                >
                  <OrderCard
                    onWaShare={onWaShare}
                    // fetchCommunityLeaderOrders={() => pulledFunc(true)}
                    navigation={navigation}
                    item={item}
                    showUserName={showUserName}
                    showPhone={showPhone}
                    waText={waText}
                    setReasonsModalVisible={setReasonsModalVisible}
                    {...{ navigateToDetails, navigateToRating }}
                  />
                </TouchableOpacity>
              </>
            );
          }}
          onScroll={onScroll}
          ListEmptyComponent={emptyComponent}
          contentContainerStyle={{
            ...contentContainerStyle,
            flex: orders.length > 0 ? 0 : 1,
            paddingBottom: horizontal ? 10 : 50,
            backgroundColor: "#F4F4F4",
          }}
          onEndReached={() => {
            fetchCommunityLeaderOrders();
          }}
          initialNumToRender={10}
          windowSize={10}
          horizontal={horizontal}
          onEndReachedThreshold={0.1}
          ListFooterComponent={() =>
            orders && orders.length && loading ? (
              <ActivityIndicator size="large" color={colors.primary} />
            ) : (
              <></>
            )
          }
          // refreshControl={
          //   <RefreshControl
          //     style={{
          //       position: "absolute",
          //       top: 0,
          //       zIndex: 99,
          //     }}
          //     refreshing={isPulled}
          //     onRefresh={() => {
          //       alert("hi");
          //       pulledFunc(true);
          //       clearSearchQuery();
          //     }}
          //     colors={[colors.primary]}
          //   />
          // }
        />
      )}
    </>
  );
};

export default OrdersListView;

const styles = StyleSheet.create({
  btnContainer: {
    padding: 10,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  singleOrder: {
    marginLeft: 15,
    width: scale(360),
    backgroundColor: colors.white,
  },
  singleOrderHorizontal: {
    marginHorizontal: 15,
    width: scale(360),
    backgroundColor: colors.white,
    borderRadius: 8,
    marginBottom: 16,
  },
  allOrders: { width: "100%" },
  orderList: {
    paddingLeft: 15,
    width: scale(330),
  },
  orderListLastCard: {
    paddingLeft: 15,
    marginRight: 15,
    width: scale(330),
  },
  orderNewButton: {
    width: metrics.screenWidth * 0.9,
    backgroundColor: colors.primary,
    padding: 10,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    marginTop: 10,
  },
});
